package com.karawek.core.auth.internal

import com.karawek.core.auth.api.AuthCredentialType
import com.karawek.core.auth.api.AuthSessionManager
import com.karawek.core.auth.api.AuthSessionStore
import com.karawek.core.auth.api.AuthTokenProvider
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class DefaultAuthSessionManager(
    private val tokenProvider: AuthTokenProvider,
    private val sessionStore: AuthSessionStore,
) : AuthSessionManager {

    private val mutex = Mutex()

    override suspend fun getCredential(
        type: AuthCredentialType,
    ): String? = mutex.withLock {
        // Always ask the platform auth SDK for the credential rather than
        // returning a token cached at login. The native SDKs keep the JWT fresh
        // via their background heartbeat; the JVM provider refreshes on demand.
        tokenProvider.currentCredential(type)
    }

    override suspend fun invalidateLocal() {
        mutex.withLock {
            // Clears the persisted UI session state. The SDK owns its own
            // session lifecycle and is signed out separately via the
            // Authenticator when the user explicitly logs out.
            sessionStore.clear()
        }
    }
}
